import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleModal } from 'actions/appAction';

import { Button } from '../common/Button/Button';
import { DiskButton } from '../common/DiskButton/DiskButton';
import { NavBar } from '../common/Layout/NavBar/NavBar';
import { ModalBody, ModalContainer, ModalViewport } from '../common/Modal/styles';

const ModalComponent = ({ canCloseModal = true, modalRef = null, ...props }) => {
    const ref = useRef(null);
    const [isScroll, setScroll] = useState(false);

    useEffect(() => {
        if (__isBrowser__) {
            document.body.style.overflow = 'hidden';
        }
        return () => {
            if (__isBrowser__ && !props.isShowPopup && !props.isShowModal) {
                document.body.style.overflow = '';
            }
        };
    }, [props.isShowModal, props.isShowPopup]);

    useEffect(() => {
        if (props.isShowPopup) {
            document.removeEventListener('keydown', keyPressHandler);
        } else if (canCloseModal && __isBrowser__) {
            document.addEventListener('keydown', keyPressHandler);
        }
        return () => {
            document.removeEventListener('keydown', keyPressHandler);
        };
    }, [props.isShowPopup]);

    const handleScroll = () => {
        setScroll(ref?.current?.scrollTop !== 0);
    };

    const keyPressHandler = (e) => {
        if (e.keyCode === 27 && !props.isShowPopup) {
            e.preventDefault();
            if (modalRef?.current) {
                modalRef.current?.close();
            } else {
                props.toggleModal(false);
            }
        }
    };

    const onCloseClick = (e) => {
        if (props.onCloseIconClick) {
            props.onCloseIconClick(e);
        } else {
            if (modalRef?.current) {
                modalRef.current?.close();
            } else {
                props.toggleModal(false);
            }
        }
    };

    return (
        <ModalContainer data-testid={props.dataTestId}>
            <ModalViewport onScroll={handleScroll} ref={ref}>
                <ModalBody isVerticalCentered={props.isVerticalCentered} hasBottomPanel={props.hasBottomPanel} fullSizeModal={props.fullSizeModal}>
                    {props.children}
                </ModalBody>
                {(canCloseModal || props.rightHeaderComponent) && (
                    <NavBar align={props.rightHeaderComponent && !canCloseModal ? 'right' : 'space-between'}>
                        {canCloseModal && (
                            <DiskButton
                                to={props.linkTo ? props.linkTo : '#'}
                                onClick={onCloseClick}
                                iconName={props.isIconClose ? 'cross' : 'arrow-back'}
                                raised={isScroll}
                            />
                        )}
                        {props.onClickMoreIcon && (
                            <>
                                {props.isButtonWithIcon ? (
                                    <Button
                                        caption={props.helpAndMore}
                                        onClick={props.onClickMoreIcon}
                                        type="link"
                                        iconName="dots"
                                        raised={isScroll}
                                        variant={'tertiary'}
                                        size={'tight'}
                                    />
                                ) : (
                                    <DiskButton onClick={props.onClickMoreIcon} type="tagA" iconName="dots" raised={isScroll} />
                                )}
                            </>
                        )}
                        {props.rightHeaderComponent && props.rightHeaderComponent}
                    </NavBar>
                )}
            </ModalViewport>
        </ModalContainer>
    );
};

const mapStateToProps = ({ app }) => {
    return {
        isShowPopup: app.isShowPopup,
        isShowModal: app.isShowModal,
    };
};
export default connect(mapStateToProps, { toggleModal })(ModalComponent);

ModalComponent.propTypes = {
    canCloseModal: PropTypes.bool,
    isIconClose: PropTypes.bool, // когда нужен крестик вместо стрелки
    linkTo: PropTypes.string,
    onCloseIconClick: PropTypes.func,
    onClickMoreIcon: PropTypes.func,
    isVerticalCentered: PropTypes.bool,
    hasBottomPanel: PropTypes.bool,
    modalRef: PropTypes.shape({ current: PropTypes.object }),
    isButtonWithIcon: PropTypes.bool,
};
